import {
    IconPath,
    IconSVG,
    IconSVGComponentProps,
} from '@/components/common/icons/IconComponent';
import React, { FC } from 'react';

export const MoneyPlus: FC<IconSVGComponentProps> = ({ ...props }) => {
    return (
        <IconSVG viewBox="0 0 21 21" fill="none" {...props}>
            <IconPath
                strokeWidth={1.4}
                stroke="currentColor"
                d="M3 8.83333V7.16667C3 6.24619 3.74619 5.5 4.66667 5.5H6.33333M3 8.83333C4.11111 8.83333 6.33333 8.16667 6.33333 5.5M3 8.83333V12.1667M18 8.83333V7.16667C18 6.24619 17.2538 5.5 16.3333 5.5H14.6667M18 8.83333C16.8889 8.83333 14.6667 8.16667 14.6667 5.5M18 8.83333V10.5M6.33333 5.5H14.6667M3 12.1667V13.8333C3 14.7538 3.74619 15.5 4.66667 15.5H6.33333M3 12.1667C4.11111 12.1667 6.33333 12.8333 6.33333 15.5M6.33333 15.5H9.66667M15.5 13V15.5M15.5 15.5V18M15.5 15.5H13M15.5 15.5H18M12.1667 10.5C12.1667 11.4205 11.4205 12.1667 10.5 12.1667C9.57953 12.1667 8.83333 11.4205 8.83333 10.5C8.83333 9.57953 9.57953 8.83333 10.5 8.83333C11.4205 8.83333 12.1667 9.57953 12.1667 10.5Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconSVG>
    );
};
